import { SectionConfigBuilder } from '../ThemeConfigBuilder';
import { body, headline, overline } from '../fields/fields';

export default new SectionConfigBuilder()
  .setContext('picker', {
    label: 'Post Content',
    description: 'Post content display',
    icon: 'Post',
  })
  .setContext('editor', {
    label: 'Post Content Section',
    description: '',
    icon: 'Post',
  })
  .addLayout('layout1', (layout) => {
    layout
      .setDescription('Post Content Only')
      .setIcon('PostLayout6')
      .setInsetBlock((block) => {
        block.setText([overline, headline, body]);
        block.setMedia(0);
        block.setActions(0);
      })
      .addBlock((block) => {
        block.setText([]);
        block.setMedia(0);
        block.setActions(0);
      });
  })
  .build();
